(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { isInteger } from '../../utils/number.js';
var n1 = 'number';
export function isIntegerNumber(x) {
  return isInteger(x);
}
isIntegerNumber.signature = n1;
export function isNegativeNumber(x) {
  return x < 0;
}
isNegativeNumber.signature = n1;
export function isPositiveNumber(x) {
  return x > 0;
}
isPositiveNumber.signature = n1;
export function isZeroNumber(x) {
  return x === 0;
}
isZeroNumber.signature = n1;
export function isNaNNumber(x) {
  return Number.isNaN(x);
}
isNaNNumber.signature = n1;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(n1, "n1", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/utils.js");
  reactHotLoader.register(isIntegerNumber, "isIntegerNumber", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/utils.js");
  reactHotLoader.register(isNegativeNumber, "isNegativeNumber", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/utils.js");
  reactHotLoader.register(isPositiveNumber, "isPositiveNumber", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/utils.js");
  reactHotLoader.register(isZeroNumber, "isZeroNumber", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/utils.js");
  reactHotLoader.register(isNaNNumber, "isNaNNumber", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/utils.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();